import React, { useContext, useLayoutEffect, useEffect, useState } from "react";
import { PortalContext } from "App";
import OPOffIframe from "pages/iframe-component/operation-offline/OPOffIframe";

const OfflineEmployeeDetail = ({ path, redirectFn }) => {
  const stateContext = useContext(PortalContext);
  const { detailPageState } = stateContext;

  const [employeeId, setEmployeeId] = useState("");

  useLayoutEffect(() => {
    const sessionState = JSON.parse(sessionStorage.getItem("state"));
    if (detailPageState && detailPageState[path]) {
      setEmployeeId(detailPageState[path].employeeId);
    } else if (sessionState && sessionState[path]) {
      setEmployeeId(sessionState[path].employeeId);
    } else {
      if (employeeId == "") setEmployeeId("close");
    }
  }, [detailPageState[path]]);

  useEffect(() => {
    if (employeeId == "close") {
      redirectFn("close", { tabId: path });
    }
  }, [employeeId]);

  // uses /merchant/list with merchantIdRedirect query parameter to redirect into merchant/info with the desired merchantId
  const urlPath = `/employee/list${
    employeeId ? "?employeeIdRedirect=" + employeeId : ""
  }`;

  return <OPOffIframe path={urlPath} />;
};

export default React.memo(OfflineEmployeeDetail);
